import { AllocationDefinitionDTO } from "../DTO/allocationDefinitionDTO";
import { AllocationProtocol } from "./allocationProtocol";
import { FileDefinition } from "./fileDefinition";

export class AllocationDefinition{

    public id!: number;
    public name!: string;
    public description!: string;
    public fileDefinition!: FileDefinition;
    public allocationProtocols!: AllocationProtocol[];
    public version!: number; //incremental version number set by server
    public published!: boolean; //if true, then can be used for moovs and can be loaded by other users
    public added!: Date;
    public deleted!: boolean;
    public ownedByEntityId!: number;
    public ownerEntityType!: string;

    constructor(){
        this.allocationProtocols = new Array();
    }

    public setFileDefinition(fd:FileDefinition){
        //use this method to correctly instantiate the protocols
        this.fileDefinition=fd;
        if(fd) this.allocationProtocols.forEach(p=>p.createFieldDefinitions(fd.fieldDefinitions));
    }

    public static mapFromDTO(param:AllocationDefinitionDTO):AllocationDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new AllocationDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.allocationProtocols = param.allocationProtocols.map(ap=>AllocationProtocol.mapFromDTO(ap));
            obj.version = param.version;
            obj.published = param.published;
            obj.added = new Date(param.added);
            obj.deleted = param.deleted;
            obj.ownedByEntityId = param.ownedByEntityId;
            obj.ownerEntityType = param.ownerEntityType;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:AllocationDefinition):AllocationDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new AllocationDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.fileDefinitionId = param.fileDefinition.id!;
            dto.allocationProtocols = param.allocationProtocols.map(ap=>AllocationProtocol.mapToDTO(ap));
            dto.version = param.version;
            dto.published = param.published;
            if(param.added) dto.added = param.added.toISOString();
            dto.deleted = param.deleted;
            dto.ownedByEntityId = param.ownedByEntityId;
            dto.ownerEntityType = param.ownerEntityType
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }

    //use DTO to create a deep copy
    get clone():AllocationDefinition{
        let mappedAllocationDefinition=AllocationDefinition.mapToDTO(this);
        mappedAllocationDefinition.id=0;
        mappedAllocationDefinition.name="";
        mappedAllocationDefinition.version=0;
        mappedAllocationDefinition.description="";
        mappedAllocationDefinition.published=false;
        mappedAllocationDefinition.allocationProtocols.forEach(p=>{
            p.id=0;
            p.allocationRules.forEach(r=>{
                r.id=0;

            });
        });
        let mapFromDTOAllocationDefinition = AllocationDefinition.mapFromDTO(mappedAllocationDefinition);
        mapFromDTOAllocationDefinition.setFileDefinition(this.fileDefinition);
        return mapFromDTOAllocationDefinition;
    }

    public resetIds(){
        this.id=0;
        this.allocationProtocols.forEach(p=>{
            p.id=0;
            p.allocationRules.forEach(r=>r.id=0);
        });
    }

    get acceptFileTypes(){
        let types=".txt";
        if(this.fileDefinition?.type=='csv') types+=",.csv,.xml";
        return types
    }
}